import { axiosInstance } from "../axios";

export const loginVoalle = async ({ username, password, idp }) => {
    return axiosInstance
        .post(`/voalle/login/`, {
            username,
            password,
            idp
        })
};